export const AccordionHeaderParamsTexts = {
  HeaderDefaultTitle: 'Цель кредита',
  HeaderDefaultDescription: 'Заполните данные',
};

export const CreditCardAccordionHeaderParamsTexts = {
  ...AccordionHeaderParamsTexts,
  HeaderDefaultTitle: 'Кредитный лимит',
};
